<template>
  <span>
    <!-- Begin Recommendation  -->
    <div v-if="recommendationAvailable" class="d-flex align-items-center float-right mt-4">
      <div class="d-flex align-items-center">
        <label class="switch-label">{{ $t("common.recommendations") }}</label>
        <b-form-checkbox v-model="showRecommendations" name="check-button" switch class="switch"></b-form-checkbox>
      </div>
    </div>

    <template v-if="showRecommendations">
      <h4 class="mt-4">
        {{ $t("common.recommendations") }}
      </h4>
      <div class="bg-white">
        <table class="table table-bordered table-striped">
          <thead class="bg-secondary text-white">
            <tr>
              <th>{{ $t("processing-transfering.purpose.text") }}</th>
              <th>{{ $t("processing-transfering.legal-reason.text") }}</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="item in recommendations.docs" :key="item._id">
              <td>
                <ol>
                  <li v-for="purpose in item.purposes" :key="purpose._id">{{ purpose.name | translate }}</li>
                </ol>
              </td>
              <td>
                <ol>
                  <li v-for="legalReason in item.legalReasons" :key="legalReason._id">{{ legalReason.name | translate }}</li>
                </ol>
              </td>
              <td>
                <sweet-button @click="applyRecommendation(item)" variant="secondary" icon="mdi mdi-check" size="sm">
                  {{ $t("common.apply-recommendation") }}
                </sweet-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Begin: Pagination -->
      <div v-if="recommendations" class="row">
        <div class="col">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination
              v-model="recommendationRequest.options.page"
              :total-rows="recommendations.totalDocs"
              :per-page="recommendations.limit"
              limit="10"
              size="sm"
            ></b-pagination>
          </ul>
        </div>
      </div>
      <!-- End: Pagination -->
    </template>
    <!-- End: Recommendation -->
  </span>
</template>

<script>
export default {
  data() {
    return {
      recommendationRequest: {
        options: { page: 1, limit: 5 },
        query: {},
      },
    };
  },
  computed: {
    showRecommendations: {
      get() {
        return this.$store.getters["datasubjectProcessingLegal/showRecommendations"];
      },
      set(value) {
        this.$store.commit("datasubjectProcessingLegal/showRecommendations", value);
      },
    },
    recommendations() {
      return this.$store.getters["datasubjectProcessingLegal/recommendations"];
    },
    recommendationAvailable() {
      return this.recommendations?.docs?.length > 0;
    },
    criteria() {
      return this.$store.getters["inventoryFilter/criteria"];
    },
  },

  watch: {
    criteria: {
      deep: true,
      immediate: true,
      handler() {
        this.fethcRecommendation();
      },
    },
    recommendationRequest: {
      deep: true,

      handler() {
        this.fethcRecommendation();
      },
    },
  },
  methods: {
    async fethcRecommendation() {
      const isLoading = this.$store.getters["datasubjectProcessingLegal/isLoading"];
      if (isLoading) {
        return;
      }
      await this.$store.dispatch("datasubjectProcessingLegal/paginateRecommendation", { pagination: this.recommendationRequest });
    },

    applyRecommendation(item) {
      this.$emit("onApply", item);
    },
  },
};
</script>

<style></style>
